const ON_CHANGE_DEBOUNCE_TIMER = 300;

const PUB_SUB_EVENTS = {
  cartUpdate: 'cart-update',
  addToCart: 'add-to-cart',
  facetsUpdate: 'facets-update',
  quantityUpdate: 'quantity-update',
  variantChange: 'variant-change',
  cartError: 'cart-error',
  accountCreated: 'account-created',
  newsletterSubscribed: 'newsletter-subscribed',
  wishlistAdded: 'wishlist-added',
  noSearchResult: 'no-result',
  answerChanged: 'answerChanged',
  showQuestion: 'showQuestion'
};

const SPACEBAR_KEY_CODE = [0,32];
const ENTER_KEY_CODE = 13;
const DOWN_ARROW_KEY_CODE = 40;
const UP_ARROW_KEY_CODE = 38;
const ESCAPE_KEY_CODE = 27;
